<script>
import cookie from "../util/cookie";

export default {
  components: {},
  data() {
    return {
      userInfo: {},
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  mounted() {
    // let user = JSON.parse(cookie.getCookie("user"));
    let user = JSON.parse(localStorage.chosedMedia);
    this.userInfo = user;
    console.log(user);
    console.log("user", cookie.getCookie("user"));
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between"
      >
        <!-- <h4 class="mb-0 font-size-18">{{ title }}</h4> -->
        <div class="avatarBox">
          <el-avatar :size="100" :src="userInfo.avatar"></el-avatar>
          <p style="font-size: 18px;font-weight: 600;">
            {{ userInfo.name }}
          </p>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
<style lang="scss" scoped>
.el-avatar > img {
  width: 100%;
}
.avatarBox {
  text-align: center;
  width: 100%;
  margin-top: 5rem;
  img {
    width: 100%;
  }
}
</style>
<style>
.el-avatar > img {
  width: 100%;
}
</style>
